module.exports = {"TXTCLI_Preview":{"id":"TXTCLI_Preview","defaultMessage":"Aperçu"},"TXTCLI_Report_3":{"id":"TXTCLI_Report_3","defaultMessage":"Compte-rendu"}}